import VTooltip, { VPopover } from 'v-tooltip';
import Vue from 'vue';

Vue.use(VTooltip, {
    defaultDelay: { show: 200 },
    defaultPlacement: 'top',
});

Vue.component('v-popover', VPopover);
